import React, { Component } from 'react'
import Icon from 'svg-inline-react'
import { Icon as TideIcon, Button } from '@driftt/tide-core-legacy'
import * as CONSTANTS from 'app/modules/rules/constants'
import { regions } from 'components/settings/Rules/constants/regions'
import { continents } from 'components/settings/Rules/constants/continents'
import { TECH_TAGS } from 'components/settings/Rules/constants/tech_tags'
import { isEmpty } from 'lodash'

import GEO_ICON from '!svg-inline?removeTags=true!images/svg/geolocation.svg'
import FIRMOGRAPHICS_ICON from '!svg-inline?removeTags=true!images/svg/firmographics-small.svg'
import ARROW_ICON from '!svg-inline?removeTags=true!images/svg/marker.svg'
import SITE_VISIT_ICON from '!svg-inline?removeTags=true!images/icons/window-settings.svg'
import LINK_ICON from '!svg-inline?removeTags=true!images/icons/link-icon.svg'
import SALESFORCE_ICON from '!svg-inline?removeTags=true!images/svg/sf-small.svg'
import TARGETING_MAP_LOCATION_ICON from '!svg-inline?removeTags=true!images/svg/targeting-map-location.svg'
import LEANDATA_ICON from '!svg-inline?removeTags=true!images/logos/leandata.svg'	
import cx from 'classnames'


const newLineValues = ['clearbit_employees', 'clearbit_raised', 'clearbit_tags_company', 'clearbit_tags_market', 'siteVisits', 'clearbit_tech', 'clearbit_state', 'clearbit_country', 'clearbit_postal_code']

class RuleFilters extends Component {

  displayType(type) {
    return CONSTANTS.CONDITION_TYPE_LABELS[type]
  }

  displayIcon(type) {
    const ICONS = {
      [CONSTANTS.GEO_FILTER_TYPES.STATE]: GEO_ICON,
      [CONSTANTS.GEO_FILTER_TYPES.COUNTRY]: GEO_ICON,
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.EMPLOYEES]: FIRMOGRAPHICS_ICON,
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.MONEY_RAISED]: FIRMOGRAPHICS_ICON,
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.COMPANY_CATEGORIES]: FIRMOGRAPHICS_ICON,
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.MARKET_CATEGORIES]: FIRMOGRAPHICS_ICON,
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.TECH_TAGS]: FIRMOGRAPHICS_ICON,
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.REVENUE]: FIRMOGRAPHICS_ICON,
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_AUDIENCE]: FIRMOGRAPHICS_ICON,
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_INDUSTRY]: FIRMOGRAPHICS_ICON,
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_SUB_INDUSTRY]: FIRMOGRAPHICS_ICON,
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_EMPLOYEE_COUNT]: FIRMOGRAPHICS_ICON,
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_EMPLOYEE_RANGE]: FIRMOGRAPHICS_ICON,
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_ANNUAL_SALES]: FIRMOGRAPHICS_ICON,
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_MARKETING_ALIAS]: FIRMOGRAPHICS_ICON,
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_REVENUE_RANGE]: FIRMOGRAPHICS_ICON,
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_HEADQUARTERS_CITY]: FIRMOGRAPHICS_ICON,
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_HEADQUARTERS_STATE]: FIRMOGRAPHICS_ICON,
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_HEADQUARTERS_COUNTRY]: FIRMOGRAPHICS_ICON,
      [CONSTANTS.DISPLAY_WHEN_FILTER_TYPES.SITE_VISITS]: SITE_VISIT_ICON,
      [CONSTANTS.URL_FILTER_TYPES.URL_PATH]: LINK_ICON,
      [CONSTANTS.URL_FILTER_TYPES.URL_HOST]: LINK_ICON,
      [CONSTANTS.URL_FILTER_TYPES.URL_QUERY]: LINK_ICON,
      [CONSTANTS.SALESFORCE_FILTER]: SALESFORCE_ICON,
      [CONSTANTS.TARGETED_ACCOUNTS_FILTER]: TARGETING_MAP_LOCATION_ICON,
      [CONSTANTS.LEANDATA_FILTER]: LEANDATA_ICON,
    }

    return <Icon src={ICONS[type]} className={type} />
  }

  displayOperator(operator, type) {
    //some of our conditions (like firmographics) have sub-types and are handled differently
    return CONSTANTS.SUB_TYPE_LABELS[type]
      ? CONSTANTS.SUB_TYPE_LABELS[type]
      : CONSTANTS.OPERATOR_LABELS[operator]
  }

  displayValue({ value, field, operator }) {
    const conditionType = CONSTANTS.CONDITION_TYPES[field]

    if (conditionType === 'LeanData') {return conditionType}
    if (conditionType === 'GEO') {return this.formatGeoValue(value, field)}
    if (conditionType === 'FIRMOGRAPHIC') {return this.formatFirmographicValue(value, field, operator)}
    if (conditionType === 'DISPLAY_WHEN') {return this.formatDisplayWhenValue(value, field)}
    if (conditionType === 'URL') {return this.formatURLValues(value, field, operator)}
    if (conditionType === 'Targeted Account') {return value}
  }

  formatURLValues = (value, _, operator) => {
    switch (operator){
      case 'isAnyOf':
        return `is ${value}`
      case 'notIsAnyOf':
        return `is not ${value}`
      case 'includesAnyOf':
        return `includes ${value}`
      default:
        return `${value}`
    }
  }

  formatNumericalValues = (value, operator) => {
    switch (operator) {
      case 'isBetween':
        return `is between ${value.min} and ${value.max}`
      case 'greaterThan':
        return `is greater than ${value}`
      case 'lessThan':
        return `is less than ${value}`
      default:
        return `${value}`
    }
  }

  formatFirmographicValue(value, field, operator) {
    const typeValues = {
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.EMPLOYEES]: `${value.min} - ${value.max} employees`,
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.MONEY_RAISED]: `$${value.min} - $${value.max} million`,
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.COMPANY_CATEGORIES]: `${Array.isArray(value) && value.join(', ')}`,
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.MARKET_CATEGORIES]: `${Array.isArray(value) && value.join(', ')}`,
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.TECH_TAGS]: `${Array.isArray(value) && value.map((key) => TECH_TAGS[key]).join(', ')}`,
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.HEADQUARTERS_STATE]: this.formatGeoValue(value, field),
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.HEADQUARTERS_COUNTRY]: this.formatGeoValue(value, field),
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.HEADQUARTERS_POSTAL_CODE]: `${Array.isArray(value) && value.join(', ')}`,
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.REVENUE]: `${value} in annual revenue`,
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_AUDIENCE]: `${value}`,
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_MARKETING_ALIAS]: `${value}`,
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_INDUSTRY]: `${value}`,
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_SUB_INDUSTRY]: `${value}`,
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_EMPLOYEE_COUNT]: this.formatNumericalValues(value, operator),
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_EMPLOYEE_RANGE]: `${value}`,
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_ANNUAL_SALES]: this.formatNumericalValues(value, operator),
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_REVENUE_RANGE]: `${value}`,
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_HEADQUARTERS_CITY]: `${value}`,
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_HEADQUARTERS_STATE]: this.formatGeoValue(value, field),
      [CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_HEADQUARTERS_COUNTRY]: this.formatGeoValue(value, field),
    }

    return typeValues[field]
  }

  formatDisplayWhenValue(value, type) {
    const typeValues = {
      [CONSTANTS.DISPLAY_WHEN_FILTER_TYPES.SITE_VISITS]: `${value.min} - ${value.max} site visits`,
    }

    return typeValues[type]
  }

  formatGeoValue(value, field) {
    const geoType = [CONSTANTS.GEO_FILTER_TYPES.COUNTRY,
      CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.HEADQUARTERS_COUNTRY,
      CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_HEADQUARTERS_COUNTRY
    ].includes(field) ? continents : regions
    const valueMap = [CONSTANTS.GEO_FILTER_TYPES.COUNTRY,
      CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.HEADQUARTERS_COUNTRY,
      CONSTANTS.FIRMOGRAPHIC_FILTER_TYPES.DEMANDBASE_HEADQUARTERS_COUNTRY
    ].includes(field) ? CONSTANTS.CONTINENT_LABELS : CONSTANTS.REGION_LABELS
    const matchedBucket = _.find(Object.keys(geoType), (type) => {
      return _.isEqual(geoType[type], value)
    })

    return matchedBucket ? valueMap[matchedBucket] : 'Custom'
  }

  selectFilter = (filter) => () => {
    this.props.setActiveFilter(filter)
  }

  addFilter = (e) => {
    e.stopPropagation()

    if (this.props.activePage === 'filterEditor') {
      this.props.saveActiveFilter()
    } else {
      this.props.setActivePage('filterEditor')
    }

    this.props.setActiveFilter('ADD')
  }

  removeFilter = filter => e => {
    e.stopPropagation()
    this.props.removeFilter(filter)
  }

  shouldShowActiveFilter = () => {
    const onlyOrCondition = this.props.conditions[0] || []

    if (this.props.activePage !== 'filterEditor')
      {return false}

    if (this.props.activeFilter === 'ADD')
      {return true}

    if (CONSTANTS.CONDITION_TYPES[this.props.activeFilter.field] === 'FIRMOGRAPHIC') {
      return !onlyOrCondition.find(cond => cond.field === this.props.activeFilter.field)
    }

    return !onlyOrCondition.find(cond => CONSTANTS.CONDITION_TYPES[cond.field] === CONSTANTS.CONDITION_TYPES[this.props.activeFilter.field])
  }

  buildFilterSet = () => {
    const onlyOrCondition = this.props.conditions[0] || []
    return this.shouldShowActiveFilter()
      ? [...onlyOrCondition, this.props.activeFilter]
      : onlyOrCondition
  }

  renderFilterRuleSet = () => {
    const filtersToDiplay = this.buildFilterSet()
    return filtersToDiplay.map((filter, index) => {
      if (filter === 'ADD')
        {return this.renderChooseFilterLink()}

      const newLineValue = newLineValues.includes(filter.field) ? 'rule-new-line-value' : ''
      const isActive = this.props.activePage === 'filterEditor' && this.props.activeFilter.field === filter.field
      const isActionOnlyFilter = this.props.isActionOnlyField(this.props.activeFilter.field)
      const preventPropagation = e => e.stopPropagation()

      //defaulting to first rule since we dont support ors yet
      return (
        <ul onClick={this.selectFilter(filter)} className="rule-filters-set" key={index}>
          <li>
            {this.displayIcon(filter.field)}
            {this.displayType(filter.field)}
            <span onClick={this.removeFilter(filter)}><TideIcon className="filter-close-button" height={10} name="close" /></span>
          </li>
          {!isActionOnlyFilter &&
            <li className={cx('rule-preview-geo-value', { 'active': isActive })}>
              {isActive && <Icon src={ARROW_ICON} />}
              {this.displayOperator(filter.field)}
              <span className={newLineValue}> {this.displayValue(filter)}</span>
            </li>
          }
          {index < filtersToDiplay.length - 1 && (
            <li onClick={preventPropagation} className="fitler-display-and"><span>AND</span></li>
          )}
        </ul>
      )
    })
  }

  renderChooseFilterLink = () => {
    const isActive = this.props.activePage === "filterEditor"
    const activeClass = isActive ? 'active' : ''

    return (
      <ul className="rule-filters-set" key="custom">
        <li className={`${activeClass} filter-preview-link`}>
          {isActive && <Icon src={ARROW_ICON} />}
          Choose Filter
        </li>
      </ul>
    )
  }

  render() {
    const { activeFilter, currentPageIsValid, conditions } = this.props
    const hasConditions = !isEmpty(conditions[0])
    const conditionsContainActionOnlyField = hasConditions && conditions[0].some(condition => this.props.isActionOnlyField(condition.field))
    const newFilterButtonIsDisabled = activeFilter === 'ADD'
      || activeFilter.field === 'targetedAccounts'
      || activeFilter.field === 'salesforceOwner'
      || !currentPageIsValid
      || conditionsContainActionOnlyField

    if (activeFilter.field === 'onlineUsers') {return false}

    return (
      <div className="rule-filters overview-rule">
        <h3>If conditions match...</h3>
        {this.renderFilterRuleSet()}
        <Button className="add-new-filter" size="small" type="primary" disabled={newFilterButtonIsDisabled} onClick={this.addFilter}>+ Add Filter</Button>
      </div>
    )
  }
}

export default RuleFilters



// WEBPACK FOOTER //
// ./src/scripts/components/settings/Rules/components/RulesEditorOverview/RuleFilters.js